// web-rnw twin of ./bilateralPreference.ts (see that file's header) — same
// key/shape, localStorage instead of AsyncStorage.

const KEY_PREFIX = 'jackedlogs.bilateral.v1.';

const keyFor = (slug: string): string => `${KEY_PREFIX}${slug}`;

const loadBilateralPreference = async (
  slug: string,
): Promise<1 | 2 | null> => {
  try {
    const raw = localStorage.getItem(keyFor(slug));
    if (raw === '1') return 1;
    if (raw === '2') return 2;
    return null;
  } catch {
    return null;
  }
};

export const resolveSeededLoadedSides = async (
  slug: string,
  catalogDefault: 1 | 2,
): Promise<1 | 2> => (await loadBilateralPreference(slug)) ?? catalogDefault;

export const persistBilateralPreference = async (
  slug: string,
  loadedSides: 1 | 2,
): Promise<void> => {
  try {
    localStorage.setItem(keyFor(slug), String(loadedSides));
  } catch {
    // Best-effort; the toggle still applies in-memory for this session.
  }
};
